export default __webpack_public_path__ + "static/team-member-03-370x250-31f2f27bb1be4f445bc1f92878b854a1.jpg";